import { Validation } from 'ts/interfaces/Validation';

export enum vehicleCode {
  PrivateCar,
  Limousine,
  Shuttle,
  MiniBus,
  Bus,
  BussinesSedan,
  GreenElectricCar,
  MinivanSUV,
  AdapdetCar,
  TaxiBoat,
  OtherType,
  StretchLimousine,
}

export const searchModes = [
  { value: '1', label: 'flight.round_trip' },
  { value: '0', label: 'flight.one_way' },
];

export const ownerValidation: Validation = {
  firstName: { required: true, minLength: 2, maxLength: 20, english: true },
  lastName: { required: true, minLength: 2, maxLength: 20, english: true },
  email: { required: true, email: true },
  phone: { required: true },
  message: { maxLength: 500 },
};

export const getFlightInformationValidation = (
  isAirport: boolean,
  isArrival?: boolean
): Validation => ({
  address: { required: false, maxLength: 100 },
  airline: { required: isAirport },
  flightNumber: { required: isAirport },
  pickupTime: { required: isArrival },
  serviceTime: { required: isArrival },
});

